'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _tableRow = require('../../table-row');

var _tableRow2 = _interopRequireDefault(_tableRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableBody = function (_React$Component) {
  _inherits(TableBody, _React$Component);

  function TableBody(props) {
    _classCallCheck(this, TableBody);

    var _this = _possibleConstructorReturn(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).call(this, props));

    _this.renderTableRow = _this.renderTableRow.bind(_this);
    return _this;
  }

  _createClass(TableBody, [{
    key: 'renderTableRow',
    value: function renderTableRow(row, index) {
      return _react2.default.createElement(_tableRow2.default, { key: index, row: row, selected: row.get('selected'), fields: this.props.fields, index: index });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tbody',
        null,
        this.props.rows.map(this.renderTableRow)
      );
    }
  }]);

  return TableBody;
}(_react2.default.Component);

TableBody.propTypes = {
  rows: _reactImmutableProptypes2.default.list.isRequired,
  fields: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    key: _react.PropTypes.string.isRequired,
    type: _react.PropTypes.string.isRequired,
    localizationMap: _react.PropTypes.func
  }).isRequired).isRequired
};

exports.default = TableBody;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-table/lib/components/table-body/components/TableBody.component.js
// module id = 1349
// module chunks = 1